import { DEVICE_TYPE } from "../constants";

export const isTomDevice = (deviceType) => deviceType === DEVICE_TYPE.tom;